import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-top: 1rem;
  grid-area: plans;

  @media(max-width: 820px) {
    width: 90%;
    margin: 0 auto;
  }
`;

export const Wrapper = styled.div`
  margin: 0 0 0 1.8rem;
  width: 100%;

  @media (max-width: 820px) {
    margin: 0;
  }
`;